import { QUERY_KEYS } from "@/src/config";

export const trackerQueryKeys = {
  all: [QUERY_KEYS.TRACKER_LIST] as const,
  list: (params: Record<string, unknown>) =>
    [QUERY_KEYS.TRACKER_LIST, params] as const,
  detail: (id: string) => [QUERY_KEYS.TRACKER_DETAIL, id] as const,
  records: (trackerId: string, params: Record<string, unknown>) =>
    [QUERY_KEYS.TRACKER_RECORDS, trackerId, params] as const,
  recordDetail: (recordId: string) =>
    [QUERY_KEYS.TRACKER_RECORD_DETAIL, recordId] as const,
};
